import { IconButton as IconButtonCore } from '@mui/material';
import React from 'react';

export default function IconButton(props) {
	return (
		<IconButtonCore {...props} />
	);
}
